import styled from 'styled-components'

import { Text } from '@/components'

export const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
  width: 100%;
  max-width: 1170px;

  a {
    text-decoration: none;
  }
`
export const Title = styled(Text)`
  width: 100%;
  align-self: flex-start;
  margin: 40px 0;
  border-bottom: 2px solid #202328;

  @media (max-width: 500px) {
    font-size: 24px;
    line-height: 36px;
    margin: 20px 0;
  }
`
export const Main = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  width: 100%;

  .not-results {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  @media (max-width: 791px) {
    align-items: center;
  }
`

export const List = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 100%;
  width: 100%;
  justify-content: space-between;
  justify-items: center;
  gap: 40px;
  margin-bottom: 48px;
  z-index: 0;

  @media (max-width: 1030px) {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
`
